var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongZuidahua(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.5H3a.5.5 0 00-.5.5v2.5m8-3H13a.5.5 0 01.5.5v3m0 4.5V13a.5.5 0 01-.5.5h-2.5m-5 0H3a.5.5 0 01-.5-.5v-2.5",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNSAyLjVIM0MyLjcyMzg2IDIuNSAyLjUgMi43MjM4NiAyLjUgM1Y1LjVNMTAuNSAyLjVIMTNDMTMuMjc2MSAyLjUgMTMuNSAyLjcyMzg2IDEzLjUgM1Y2TTEzLjUgMTAuNVYxM0MxMy41IDEzLjI3NjEgMTMuMjc2MSAxMy41IDEzIDEzLjVIMTAuNU01LjUgMTMuNUgzQzIuNzIzODYgMTMuNSAyLjUgMTMuMjc2MSAyLjUgMTNWMTAuNSIgc3Ryb2tlPSIjM0Y0NjVDIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgTongyongZuidahua as ReactComponent };